import { motion } from "framer-motion";
import { MdOutlineFastfood, MdKeyboardArrowDown } from "react-icons/md";
import { FoodCategory } from "../../../types";

/*
 * A category pill.
 *
 * This used to be a 6rem x 7rem icon card. With 36 categories that produced a
 * ~3,500px horizontal strip in which only four were ever on screen, so the pill
 * is deliberately compact: the label is the thing people scan, the icon is
 * secondary.
 */
const Button = ({
  category,
  filter,
  setFilter,
  hasChildren,
}: {
  category: FoodCategory;
  filter: string;
  setFilter: any;
  /** Draws a chevron so a parent reads as openable rather than terminal. */
  hasChildren?: boolean;
}) => {
  const active = category.urlParam === filter;

  return (
    <motion.button
      type="button"
      onClick={() => setFilter(category.urlParam)}
      whileTap={{ scale: 0.94 }}
      aria-pressed={active}
      title={category.name}
      className={`group flex items-center gap-2 pl-2 pr-3.5 py-1.5 rounded-full
        border cursor-pointer duration-150 transition-colors ease-out
        ${
          active
            ? "bg-cartNumBg border-cartNumBg text-white shadow-md"
            : "bg-btnOverlay border-black/5 text-textColor hover:border-cartNumBg/40 hover:text-cartNumBg"
        }`}
    >
      <span
        className={`w-6 h-6 shrink-0 rounded-full flex items-center justify-center text-sm
          ${active ? "bg-white/20 text-white" : "bg-cartNumBg/10 text-cartNumBg"}`}
      >
        {category.icon || <MdOutlineFastfood />}
      </span>
      <span className="text-xs sm:text-sm font-semibold whitespace-nowrap">
        {category.name}
      </span>
      {hasChildren && (
        <MdKeyboardArrowDown
          className={`-ml-1 text-base shrink-0 transition-transform duration-150
            ${active ? "rotate-180 text-white/80" : "text-lightGray"}`}
        />
      )}
    </motion.button>
  );
};

export default Button;
